"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var codemirror_1 = __importDefault(require("codemirror"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var CompletionIndex_1 = require("../models/CompletionIndex");

var EditorState_1 = require("../models/EditorState");

var FormulaEditorField_1 = __importDefault(require("./FormulaEditorField"));

var FormulaEditorLabel_1 = __importDefault(require("./FormulaEditorLabel"));

var HintList_1 = __importDefault(require("./HintList"));

var reducer_1 = __importDefault(require("./reducer"));

var FormulaEditor =
/** @class */
function (_super) {
  __extends(FormulaEditor, _super);

  function FormulaEditor() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      focus: false
    }; // `lastState` keeps track of the last state of the reducer.
    // It is explicitly not kept on the state object to prevent unnecessary renders.
    // This allows multiple dispatches to build off of each other and trigger only one update.

    _this.lastState = _this.props.editorState;

    _this.dispatch = function (action) {
      var onChange = _this.props.onChange;
      var prevState = _this.lastState;
      var state = reducer_1.default(prevState, action);

      if (prevState !== state) {
        _this.lastState = state;
        onChange(state);
      }
    };

    return _this;
  }

  FormulaEditor.registerLanguage = function (language) {
    var name = language.getName();
    var mode = language.getLanguageMode();
    var hints = language.getHints(); // @ts-ignore

    codemirror_1.default.defineSimpleMode(name, mode);

    if (hints) {
      codemirror_1.default.registerHelper('hint', name, hints);
    }
  };

  FormulaEditor.prototype.componentDidUpdate = function (prevProps) {
    var editorState = this.props.editorState;

    if (editorState !== prevProps.editorState) {
      this.lastState = editorState;
    }
  };

  FormulaEditor.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        completions = _a.completions,
        disabled = _a.disabled,
        editorState = _a.editorState,
        label = _a.label,
        language = _a.language,
        maxLines = _a.maxLines,
        minLines = _a.minLines,
        style = _a.style;
    var baseClassName = 'formula-editor';
    var rootClassName = className ? baseClassName + " " + className : baseClassName;
    return react_1.default.createElement("div", {
      className: rootClassName,
      style: style
    }, label ? react_1.default.createElement(FormulaEditorLabel_1.default, {
      label: label
    }) : null, react_1.default.createElement(FormulaEditorField_1.default, {
      buffer: editorState.buffer,
      completions: completions,
      disabled: disabled,
      dispatch: this.dispatch,
      language: language,
      maxLines: maxLines,
      minLines: minLines,
      showHints: editorState.showHints
    }), react_1.default.createElement(HintList_1.default, {
      hints: editorState.hints
    }));
  };

  FormulaEditor.defaultProps = {
    disabled: false,
    label: undefined,
    maxLines: undefined,
    minLines: undefined
  };
  FormulaEditor.propTypes = {
    className: prop_types_1.default.string,
    completions: CompletionIndex_1.CompletionIndex.shape.isRequired,
    disabled: prop_types_1.default.bool,
    editorState: EditorState_1.EditorState.shape.isRequired,
    label: prop_types_1.default.string,
    language: prop_types_1.default.string.isRequired,
    maxLines: prop_types_1.default.number,
    minLines: prop_types_1.default.number,
    onChange: prop_types_1.default.func.isRequired,
    style: prop_types_1.default.objectOf(prop_types_1.default.any)
  };
  return FormulaEditor;
}(react_1.PureComponent);

exports.default = FormulaEditor;